<template>
  <transition name="fade">
    <div class="video-popup" v-if="visible">
      <!-- 背景阴影 -->
      <div class="video-popup-mask" @click="handleClose"></div>

      <!-- 主体内容 -->
      <div class="video-popup-content">
        <!-- 关闭按钮 -->
        <div class="video-popup-close" @click="handleClose"></div>

        <!-- 视频容器 -->
        <div class="video-wrapper">
          <video
            v-if="videoUrl"
            :src="videoUrl"
            controls
            autoplay
            playsinline
            webkit-playsinline="true"
            mtt-playsinline="true"
            x5-video-player-type="h5"
          ></video>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  videoUrl: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:visible', 'close']);

const handleClose = () => {
  emit('update:visible', false);
  emit('close');
};
</script>

<style scoped lang="less">
</style>
